import { render, staticRenderFns } from "./PassportUnlockModal.vue?vue&type=template&id=afdd56f8&"
import script from "./PassportUnlockModal.vue?vue&type=script&lang=js&"
export * from "./PassportUnlockModal.vue?vue&type=script&lang=js&"
import style0 from "./PassportUnlockModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports